import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface FormBehaviorEntry {
  requiredOverrides: Record<string, boolean | undefined>
  disabledOverrides: Record<string, boolean | undefined>
  hiddenOverrides: Record<string, boolean | undefined>
  lookupAllowedIds: Record<string, number[] | undefined>
  lookupAllowedLabels: Record<string, string[] | undefined>
  categoryAllowedIds: Record<string, number[] | undefined>
  categoryAllowedLabels: Record<string, string[] | undefined>
  minDateOverrides: Record<string, string | undefined>
  maxDateOverrides: Record<string, string | undefined>
}

export interface FormBehaviorSliceState {
  byLayoutUid: Record<string, FormBehaviorEntry>
}

const initialState: FormBehaviorSliceState = {
  byLayoutUid: {},
}

const formBehaviorSlice = createSlice({
  name: 'formBehavior',
  initialState,
  reducers: {
    setFormBehaviorState: (
      state,
      action: PayloadAction<{ layoutUid: string; state: FormBehaviorEntry }>
    ) => {
      state.byLayoutUid[action.payload.layoutUid] = action.payload.state
    },
    clearFormBehaviorState: (state, action: PayloadAction<string>) => {
      delete state.byLayoutUid[action.payload]
    },
  },
})

export const { setFormBehaviorState, clearFormBehaviorState } =
  formBehaviorSlice.actions
export default formBehaviorSlice.reducer
